import { z } from 'zod';
import { PageQuerySchema, pageOf } from './common';

/** Kinds of records the audit trail is about (« Journal d'audit » filter). */
export const AUDIT_ENTITIES = [
  'student',
  'grade_sheet',
  'jury',
  'application',
  'user',
  'settings',
  'academic_year',
  'curriculum',
  'timetable_slot',
  'announcement',
] as const;
export type AuditEntity = (typeof AUDIT_ENTITIES)[number];

export const AuditQuerySchema = PageQuerySchema.extend({
  entity: z.enum(AUDIT_ENTITIES).optional(),
  /** yyyy-mm-dd: entries on or after this day. */
  since: z.iso.date().optional(),
});
export type AuditQuery = z.infer<typeof AuditQuerySchema>;

/**
 * One line of the trail. Who, when, what, on which record — never the stored before / after payloads
 * (grades, CIN): the record itself shows the details to whoever may read it.
 */
export const AuditEntrySchema = z.object({
  id: z.uuid(),
  at: z.string(),
  action: z.string(),
  entity: z.string(),
  entityId: z.string().nullable(),
  actorName: z.string().nullable(),
  /** Set when the entry is about a student: name and matricule, to open the record. */
  student: z.object({ id: z.uuid(), name: z.string(), matricule: z.string() }).nullable(),
});
export type AuditEntry = z.infer<typeof AuditEntrySchema>;

export const AuditPageSchema = pageOf(AuditEntrySchema);
export type AuditPage = z.infer<typeof AuditPageSchema>;
